mutation logoutMutation {
  logoutMutation {
    user {
      id
    }
  }
}
